import React, { useCallback } from 'react';
import classNames from 'classnames';
import './ResizeAdorner.less';
import { ResizeDirection } from '@decisions/server/DecisionsFramework/Design/Form/ResizeDirection';

export interface IResizeHandlerProps extends Omit<React.HTMLProps<HTMLDivElement>, 'onMouseDown'> {
  onMouseDown: (e: React.MouseEvent<HTMLElement> & { resizeDirection: ResizeDirection }) => void;
  resizeDirection: ResizeDirection;
}

export function ResizeHandler({ onMouseDown, resizeDirection, onMouseUp, ...otherProps }: IResizeHandlerProps) {
  const handleMouseDown = useCallback(
    (e: React.MouseEvent<HTMLElement>) => onMouseDown?.({ ...e, ...{ resizeDirection } }),
    [onMouseDown, resizeDirection]
  );

  return (
    <div
      className={classNames('dpc-resize-adorner__handler', getDirectionClassName(resizeDirection))}
      onMouseDown={handleMouseDown}
      onMouseUp={onMouseUp}
      {...otherProps}
    ></div>
  );
}

const getDirectionClassName = (resizeDirection: ResizeDirection) => {
  switch (resizeDirection) {
    case ResizeDirection.Left:
      return 'dpc-resize-adorner__handler--w';
    case ResizeDirection.Left | ResizeDirection.Top:
      return 'dpc-resize-adorner__handler--nw';
    case ResizeDirection.Left | ResizeDirection.Bottom:
      return 'dpc-resize-adorner__handler--sw';
    case ResizeDirection.Right | ResizeDirection.Top:
      return 'dpc-resize-adorner__handler--ne';
    case ResizeDirection.Right:
      return 'dpc-resize-adorner__handler--e';
    case ResizeDirection.Right | ResizeDirection.Bottom:
      return 'dpc-resize-adorner__handler--se';
    case ResizeDirection.Top:
      return 'dpc-resize-adorner__handler--n';
    case ResizeDirection.Bottom:
      return 'dpc-resize-adorner__handler--s';
  }
};
